require('jquery')

jQuery(function () {
  $('.offcanvas-body .menu-item').on('click', function () {
    $('.offcanvas-header .btn-close').trigger('click')
  })
})
